@if (salvando) {
  <div class="loading-overlay">
    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}

<section>
  <p class="section-title">DADOS GERAIS</p>

  <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Data de nascimento</mat-label>
        <input
          matInput
          type="date"
          [(ngModel)]="dataNascimento"
          required
          disabled
        />
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Idade</mat-label>
        <input matInput [value]="idade" disabled required/>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field
        appearance="outline"
        style="width: 100%"
        [class.mat-form-field-invalid]="erroPeso()"
      >
        <mat-label>Peso (kg)</mat-label>

        <input
          matInput
          type="text"
          mask="separator.2"
          decimalMarker=","
          thousandSeparator="."
          [(ngModel)]="peso"
          (ngModelChange)="erroPeso.set('')"
          [disabled]="formBloqueado()"
          required
        />


        <mat-error *ngIf="erroPeso()"> {{ erroPeso() }}</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field
        appearance="outline"
        style="width: 100%"
        [class.mat-form-field-invalid]="erroAltura()"
      >
        <mat-label>Altura (m)</mat-label>

        <input
          matInput
          type="text"
          mask="0,00"
          [(ngModel)]="altura"
          (ngModelChange)="this.erroAltura.set('')"
          [disabled]="formBloqueado()"
          required
        />

        <mat-error *ngIf="erroAltura()"> {{ erroAltura() }}</mat-error>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</section>

<section>
  <p class="section-title">RISCO DE COMORBIDADES</p>

  <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>IMC</mat-label>
        <input matInput [value]="imc" disabled/>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Classificação do IMC</mat-label>
        <input matInput [value]="classificacaoImc" disabled/>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="2">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Risco de comorbidades</mat-label>
        <input matInput [value]="riscoComorbidades" disabled/>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="6" style="margin-top: -2em">
      <mat-accordion class="full-width">
        <mat-expansion-panel hideToggle style="pointer-events: none">
          <mat-expansion-panel-header>
            <mat-panel-title class="accordion-title">
              @if (imcNum < 18.5) {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } @else if (imcNum < 25) {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } @else if (imcNum < 30) {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } @else if (imcNum < 35) {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } @else if (imcNum < 40) {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } @else {
                <img
                  src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                  alt=""
                />
              } Resultado do IMC: {{ imc }}
              <br/>
              @if (imcNum < 18.5) {
                Indica baixo peso e pode estar associado a
                  riscos nutricionais.
              } @else if (imcNum < 25) {
                Indica peso
                  adequado, com baixo risco de comorbidades associadas.
              } @else if (imcNum < 30) {
                Indica sobrepeso e aumento do risco para o
                  desenvolvimento de comorbidades.
              } @else if (imcNum < 35) {
                Indica
                  obesidade grau I e risco moderado de desenvolvimento de
                  comorbidades associadas.
              } @else if (imcNum < 40) {
                Indica
                  obesidade grau II e o risco de desenvolvimento de comorbidades
                  associadas é elevado.
              } @else {
                Indica obesidade grau III e o
                  risco de desenvolvimento de comorbidades associadas é muito
                  elevado.
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-grid-tile>
  </mat-grid-list>
</section>

<section>
  <p class="section-title">RISCO CARDIOVASCULAR</p>

  <mat-grid-list cols="6" rowHeight="90px" gutterSize="1em">
    <mat-grid-tile [colspan]="3">
      <mat-form-field
        appearance="outline"
        style="width: 100%"
        [class.mat-form-field-invalid]="erroCircunferenciaAbdominal()"
      >
        <mat-label>Circunferência abdominal (cm)</mat-label>

        <input
          matInput
          type="text"
          mask="separator.1"
          decimalMarker=","
          thousandSeparator="."
          [(ngModel)]="circunferenciaAbdominal"
          (ngModelChange)="erroCircunferenciaAbdominal.set('')"
          [disabled]="formBloqueado()"
          required
        />


        <mat-error *ngIf="erroCircunferenciaAbdominal()">
          {{ erroCircunferenciaAbdominal() }}
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="3">
      <mat-form-field
        appearance="outline"
        style="width: 100%"
        [class.mat-form-field-invalid]="erroEtnia()"
      >
        <mat-label>Etnia</mat-label>

        <mat-select
          [(ngModel)]="etnia"
          (ngModelChange)="erroEtnia.set('')"
          [disabled]="formBloqueado()"
        >
          <mat-option *ngFor="let opt of etnias" [value]="opt">
            {{ opt }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="erroEtnia()"> {{ erroEtnia() }}</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile [colspan]="6">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Risco cardiovascular</mat-label>
        <input matInput [value]="riscoCardiovascular" disabled/>
      </mat-form-field>
    </mat-grid-tile>

    @if (['Elevado', 'Significativamente elevado'].includes(riscoCardiovascular)) {
      <mat-grid-tile [colspan]="6" style="margin-top: -2em">
        <mat-accordion class="full-width">
          <mat-expansion-panel hideToggle style="pointer-events: none">
            <mat-expansion-panel-header>
              <mat-panel-title class="accordion-title">
                @if (imcNum < 18.5) {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } @else if (imcNum < 25) {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } @else if (imcNum < 30) {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } @else if (imcNum < 35) {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } @else if (imcNum < 40) {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } @else {
                  <img
                    src="../../../../../assets/svg/icons/eva_moderada_ic.svg"
                    alt=""
                  />
                } Risco cardiovascular {{ riscoCardiovascular.toLowerCase() }}
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-grid-tile>
    }
  </mat-grid-list>
</section>

<section>
  <p class="section-title">OUTRAS INFORMAÇÕES</p>

  <mat-grid-list cols="6" rowHeight="120px" gutterSize="1em">
    <mat-grid-tile [colspan]="6">
      <mat-form-field appearance="outline" style="width: 100%; margin-top: 1em">
        <mat-label>Outras informações</mat-label>
        <textarea
          matInput
          rows="3"
          [(ngModel)]="outrasInformacoes"
          [disabled]="formBloqueado()"
          minlength="15"
          maxlength="300"
        ></textarea>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-error *ngIf="erroOutrasInformacoes()">
    {{ erroOutrasInformacoes() }}
  </mat-error>
</section>
<div style="margin-top: 3em; display: flex; gap: 1em; justify-content: end">
  <button matButton="outlined" type="button" (click)="cancelar()">
    Cancelar
  </button>

  <button
    matButton="filled"
    type="button"
    [disabled]="formBloqueado() || salvando"
    (click)="salvarAvaliacaoFisica()"
  >
    Salvar
  </button>
</div>
